export default __webpack_public_path__ + "static/media/index2.6f03ee7d.jpeg";